/**
 * Locale-Suggestion: Detection + Mark Suggested + Show Picker.
 *
 * Anders als ein klassisches "Switch to X?"-Banner: dieser Picker zeigt ALLE
 * published Locales als Liste. Die per Detection empfohlene Sprache bekommt
 * einen .is-suggested-Marker, die aktuelle einen .is-current-Marker. Jede
 * Sprache ist klickbar — auch wenn die Detection falsch war, kann der User
 * seine Sprache erkennen und wechseln.
 *
 * Bot-Skip, Cookie 90d Persistenz.
 */
(function () {
  'use strict';

  if (isBot(navigator.userAgent)) return;

  // Test-Override: ?nzg_show_locale=1 zwingt das Banner trotz Cookie,
  // ?nzg_show_locale=reset löscht den Cookie und reloaded ohne Param.
  var override = (window.location.search.match(/[?&]nzg_show_locale=([^&]+)/) || [])[1];
  if (override === 'reset') {
    document.cookie = 'nzg_locale_suggested=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    var cleanUrl = window.location.pathname + window.location.hash;
    history.replaceState(null, '', cleanUrl);
  } else if (override !== '1') {
    if (readCookie('nzg_locale_suggested')) return;
  }

  var configEl = document.getElementById('nzg-locale-suggestion-config');
  var container = document.getElementById('nzg-locale-suggestion');
  if (!configEl || !container) return;

  var config;
  try { config = JSON.parse(configEl.textContent || '{}'); } catch (e) { return; }
  if (!config || !Array.isArray(config.supportedLocales)) return;

  var supportedLower = config.supportedLocales.map(function (l) { return l.toLowerCase(); });
  var current = String(config.currentLocale || '').toLowerCase();

  var suggested = detectLocale(config, supportedLower, current);
  // Banner nur zeigen, wenn die Detection eine andere als die aktuelle vorschlägt.
  if (!suggested || suggested === current) return;

  // Original-Casing wiederherstellen.
  var suggestedOriginal = config.supportedLocales.find(function (l) {
    return l.toLowerCase() === suggested;
  });
  if (!suggestedOriginal) return;

  // is-suggested-Marker an das richtige Item setzen.
  var items = container.querySelectorAll('.nzg-locsug__item');
  for (var i = 0; i < items.length; i++) {
    var iso = items[i].getAttribute('data-iso') || '';
    if (iso.toLowerCase() === suggested) {
      items[i].classList.add('is-suggested');
    }
  }

  // Delay vor Anzeige (1.5s): vermeidet Googles Mobile-Intrusive-Interstitial-
  // Penalty, weil Banner nicht direkt beim Page-Load erscheint. Auch UX-Hint —
  // User soll erst den Content sehen, dann den Sprachvorschlag.
  setTimeout(function () {
    container.hidden = false;
    container.setAttribute('data-visible', 'true');
  }, 1500);

  container.addEventListener('click', function (ev) {
    var target = ev.target;
    while (target && target !== container && !target.dataset.action) {
      target = target.parentNode;
    }
    if (!target || target === container) return;

    if (target.dataset.action === 'decline') {
      ev.preventDefault();
      writeCookie('nzg_locale_suggested', 'dismissed', 90);
      hide();
      return;
    }

    if (target.dataset.action === 'accept') {
      var loc = target.dataset.targetLocale || suggestedOriginal;

      // Klick auf die aktuelle Locale → Banner einfach dismissen, kein Reload.
      if (loc.toLowerCase() === current) {
        ev.preventDefault();
        writeCookie('nzg_locale_suggested', 'dismissed', 90);
        hide();
        return;
      }

      writeCookie('nzg_locale_suggested', 'accepted-' + loc, 90);

      // Modifier-Click / Middle-Click / Right-Click: Browser darf den href im
      // neuen Tab öffnen — Cookie ist gesetzt, kein preventDefault. Bei dieser
      // Verzweigung verlassen wir uns auf das href, das Liquid bereits gebaut hat.
      if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || ev.button !== 0) {
        return;
      }

      // Normaler Click → JS übernimmt Navigation mit sicherer Path-Sanitization
      // (falls request.path den Locale-Präfix wider Erwarten doch enthielte).
      ev.preventDefault();
      window.location.href = buildLocaleUrl(loc, config);
    }
  });

  function hide() {
    container.hidden = true;
    container.removeAttribute('data-visible');
  }

  function buildLocaleUrl(targetLocale, configRef) {
    var prefix = urlPrefixForLocale(targetLocale);
    var path = window.location.pathname;
    var supported = (configRef && configRef.supportedLocales) || [];
    for (var i = 0; i < supported.length; i++) {
      var existing = urlPrefixForLocale(supported[i]);
      if (!existing) continue;
      var lead = '/' + existing;
      if (path === lead || path.indexOf(lead + '/') === 0) {
        path = path.substring(lead.length) || '/';
        break;
      }
    }
    if (path.charAt(0) !== '/') path = '/' + path;
    var search = window.location.search || '';
    var hash = window.location.hash || '';
    if (!prefix) return (configRef.shopUrl || '') + path + search + hash;
    return (configRef.shopUrl || '') + '/' + prefix + path + search + hash;
  }

  function urlPrefixForLocale(loc) {
    if (!loc) return '';
    var l = String(loc).toLowerCase();
    if (l === 'en') return '';
    if (l === 'zh-cn') return 'zh';
    if (l === 'zh-hans') return 'zh';
    if (l === 'zh-tw') return 'zh-TW';
    if (l === 'zh-hant') return 'zh-TW';
    return l;
  }

  function detectLocale(cfg, supported, currentLower) {
    // 1. Eingeloggter Kunde mit explizit gesetzter Account-Locale.
    //    Hat höchste Priorität — wenn der Kunde sich registriert hat oder schon
    //    mal bestellt hat, ist customer.locale eine bewusste Wahl. Wenn die
    //    bereits zur aktuellen Locale passt: kein Vorschlag (Kunde ist richtig).
    if (cfg.customerLocale && typeof cfg.customerLocale === 'string') {
      var cl = cfg.customerLocale.toLowerCase();
      if (cl === currentLower) return null;
      if (supported.indexOf(cl) >= 0) return cl;
      // Variante (zh-hans → zh-cn)
      if (cl === 'zh-hans' && supported.indexOf('zh-cn') >= 0) return 'zh-cn';
      if (cl === 'zh-hant' && supported.indexOf('zh-tw') >= 0) return 'zh-tw';
    }

    // 2. Country-Erkennung über Shopify Markets.
    var country = null;
    try {
      if (window.Shopify && typeof window.Shopify.country === 'string') {
        country = window.Shopify.country.toUpperCase();
      }
    } catch (e) {}
    if (country && cfg.countryToLocale && cfg.countryToLocale[country]) {
      var byCountry = cfg.countryToLocale[country].toLowerCase();
      if (supported.indexOf(byCountry) >= 0 && byCountry !== currentLower) {
        return byCountry;
      }
    }

    // 3. Browser-Sprache als Fallback.
    var langs = (navigator.languages && navigator.languages.length)
      ? navigator.languages
      : (navigator.language ? [navigator.language] : []);
    for (var i = 0; i < langs.length; i++) {
      var raw = String(langs[i] || '').toLowerCase();
      if (!raw) continue;
      if (supported.indexOf(raw) >= 0) return raw;
      var base = raw.split('-')[0];
      if (supported.indexOf(base) >= 0) return base;
      if (raw === 'zh-hans' && supported.indexOf('zh-cn') >= 0) return 'zh-cn';
      if (raw === 'zh-hant' && supported.indexOf('zh-tw') >= 0) return 'zh-tw';
    }
    return null;
  }

  function readCookie(name) {
    var parts = document.cookie ? document.cookie.split(';') : [];
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i].trim();
      if (p.indexOf(name + '=') === 0) return decodeURIComponent(p.substring(name.length + 1));
    }
    return null;
  }

  function writeCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + encodeURIComponent(value)
      + '; expires=' + d.toUTCString()
      + '; path=/; SameSite=Lax';
  }

  function isBot(ua) {
    if (!ua) return false;
    return /bot\b|crawler|spider|slurp|bingpreview|facebookexternalhit|whatsapp/i.test(ua);
  }
})();
